import axios from 'axios';
import { httpResponse } from './api-response-status';
import apiClient from './setup';

const authentication = async ({
  email_whatsapp,
  password,
}: {
  email_whatsapp: string;
  password: string;
}) => {
  try {
    const response = await apiClient.post('/api/user/authentication', {
      email_whatsapp: email_whatsapp,
      password: password,
    });
    return httpResponse('SUCCESS', response.data);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return httpResponse('ERROR', error.response?.data);
    } else {
      return httpResponse('PANICO', error);
    }
  }
};

const recoverFindEmailWhatsapp = async (
  email_whatsapp: string,
  response?: (data: any) => void,
  errorResponse?: (error: any) => void
) => {
  try {
    const result = await apiClient.post('/api/user/recover', {
      email_whatsapp: email_whatsapp,
    });
    if (response === undefined) {
      return httpResponse('SUCCESS', result.data);
    } else {
      response(result.data);
    }
  } catch (error) {
    if (errorResponse === undefined) {
      if (axios.isAxiosError(error)) {
        return httpResponse('ERROR', error.response?.data);
      }
    } else {
      if (axios.isAxiosError(error)) {
        errorResponse(error.response?.data);
      }
    }
  }
};

const confirmationCode = async (
  {
    email,
    hash_confirmation,
    type,
  }: {
    email: string;
    hash_confirmation: string;
    type: 'RECOVER' | 'CREATION';
  },
  response?: (data: any) => void,
  errorResponse?: (error: any) => void
) => {
  try {
    const result = await apiClient.post(
      '/api/user/confirmation',
      {
        email: email,
        hash_confirmation: hash_confirmation,
      },
      {
        params: {
          type: type,
        },
      }
    );

    if (response === undefined) {
      return httpResponse('SUCCESS', result.data);
    } else {
      response(result.data);
    }
  } catch (error) {
    if (errorResponse === undefined) {
      if (axios.isAxiosError(error)) {
        return httpResponse('ERROR', error.response?.data);
      }
    } else {
      if (axios.isAxiosError(error)) {
        errorResponse(error.response?.data);
      }
    }
  }
};

export const user = {
  authentication,
  recoverFindEmailWhatsapp,
  confirmationCode,
};
